import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * Cette page redirige vers /mon-espace-joueur pour une expérience unifiée.
 * L'ancienne page d'inscription séparée n'est plus utilisée.
 */
const GameRegisterPublicPage = () => {
  const navigate = useNavigate();
  const { gameId } = useParams();

  useEffect(() => {
    // Redirect to unified player space with game context
    navigate('/mon-espace-joueur', { 
      replace: true,
      state: { fromGame: gameId }
    });
  }, [navigate, gameId]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900 flex items-center justify-center">
      <div className="text-white text-center">
        <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p>Redirection vers l'espace joueur...</p>
      </div>
    </div>
  );
};

export default GameRegisterPublicPage;
